export default __webpack_public_path__ + "assets/icons/doc-upload-type.c2efce86.svg";